import { API_BASE_URL, ensureCsrfToken } from "./apiClient";

const MUTATING_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);

const CSRF_OPTIONAL_PATHS = new Set([
  "/api/v1/automap/dealer-portal/auth/login",
  "/api/v1/automap/dealer-portal/auth/logout",
]);

function networkErrorMessage() {
  if (!API_BASE_URL) {
    return "Unable to reach the API. Run the API on port 5001 (cd server && npm run dev) and the React app via npm start in client/ so /api requests are proxied.";
  }
  return `Unable to reach the API at ${API_BASE_URL}. Make sure the server is running (npm run dev in server/). If you use localhost:3000 for the UI, leave REACT_APP_API_BASE_URL unset in client/.env.local and restart npm start.`;
}

function needsCsrfToken(method, path) {
  if (!MUTATING_METHODS.has(method)) {
    return false;
  }
  return !CSRF_OPTIONAL_PATHS.has(path);
}

export async function dealerPortalFetch(path, options = {}) {
  const method = (options.method || "GET").toUpperCase();
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  try {
    if (needsCsrfToken(method, path)) {
      headers["X-CSRF-Token"] = await ensureCsrfToken();
    }

    const response = await fetch(`${API_BASE_URL}${path}`, {
      ...options,
      method,
      credentials: "include",
      headers,
    });

    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = new Error(body.message || `Request failed (${response.status})`);
      error.status = response.status;
      throw error;
    }
    return body;
  } catch (error) {
    if (error?.status) {
      throw error;
    }
    throw new Error(networkErrorMessage());
  }
}

async function dealerFetch(path, options = {}) {
  return dealerPortalFetch(path, options);
}

export function dealerLogin(email, password) {
  return dealerFetch("/api/v1/automap/dealer-portal/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export function dealerLogout() {
  return dealerFetch("/api/v1/automap/dealer-portal/auth/logout", { method: "POST" });
}

export function getDealerMe(dealerId) {
  const qs = dealerId ? `?dealerId=${encodeURIComponent(dealerId)}` : "";
  return dealerFetch(`/api/v1/automap/dealer-portal/auth/me${qs}`);
}
